function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ukb{fill:#fff;}.ukc{fill:#012169;}.ukd{fill:red;}"));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  className: "ukc",
  width: 100,
  height: 60.01
});

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  className: "ukb",
  points: "100 20.72 59.3 20.72 59.3 .01 40.71 .01 40.71 20.72 0 20.72 0 39.3 40.71 39.3 40.71 60.01 59.3 60.01 59.3 39.3 100 39.3 100 20.72"
});

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  className: "ukb",
  points: "100 3.7 55.97 30.02 100 56.4 100 60.01 94.1 60.01 50.01 33.57 5.78 60.01 0 60.01 0 56.34 44.03 30.02 0 3.64 0 0 5.87 0 50.01 26.44 94.25 0 100 0 100 3.7"
});

var _ref6 = /*#__PURE__*/React.createElement("polygon", {
  className: "ukd",
  points: "100 23.23 56.79 23.23 56.79 .01 43.22 .01 43.22 23.23 0 23.23 0 36.79 43.22 36.79 43.22 60.01 56.79 60.01 56.79 36.79 100 36.79 100 23.23"
});

var _ref7 = /*#__PURE__*/React.createElement("polygon", {
  className: "ukd",
  points: "39.47 39.29 4.8 60.01 .17 60.01 34.82 39.29 39.47 39.29"
});

var _ref8 = /*#__PURE__*/React.createElement("polygon", {
  className: "ukd",
  points: "100 0 100 .29 65.85 20.72 61.25 20.72 95.87 0 100 0"
});

var _ref9 = /*#__PURE__*/React.createElement("polygon", {
  className: "ukd",
  points: "100 57.41 100 60.01 99.77 60.01 65.18 39.29 69.78 39.29 100 57.41"
});

var _ref10 = /*#__PURE__*/React.createElement("polygon", {
  className: "ukd",
  points: "34.24 20.72 29.64 20.72 0 2.98 0 .2 34.24 20.72"
});

var SvgFlagUk = function SvgFlagUk(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    width: 100,
    height: 60,
    viewBox: "0 0 100 60",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFlagUk, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/FlagUK.661e1af6.svg";
export { ForwardRef as ReactComponent };